import { Form } from "./types";
import "./IncomeHandler.scss";
import { useL10n } from "../../../../../l10n";
import { useCallback } from "react";
import { Line } from "../../../../../ducks/data/deliveries/types";
import EditSurchargeRow from "./EditSurchargeRow";
import InvoiceLineRowForm from "./InvoiceLineRowForm";

const EditInvoiceLineRow = (props: {
  line: Line;
  clientId?: string;
  deliveryId: string;
  onUpdate: (id: string, line: any) => Promise<unknown>;
  onUpdateSurcharge: (id: string, percentage: string) => Promise<unknown>;
  onCancel: () => void;
  onAfterEdit: () => void;
  noCheckboxes: boolean;
  showStatusColumn?: boolean;
}) => {
  const {
    line,
    onUpdate,
    onUpdateSurcharge,
    onAfterEdit,
    onCancel,
    clientId,
    noCheckboxes,
    showStatusColumn,
  } = props;
  const l10n = useL10n();
  const handleSubmit = useCallback(
    async (form: Form) => {
      // TODO: round up/down here?
      await onUpdate(line.id, {
        ...form,
        quantity: form.quantity.toString(),
        amount: form.amount.toString(),
        discountPercentage: form.discountPercentage?.toString() || null,
      });
      onAfterEdit();
    },
    [onUpdate, line, onAfterEdit]
  );

  return hasSurcharge(line) ? (
    <EditSurchargeRow
      line={line}
      onUpdateSurcharge={onUpdateSurcharge}
      onCancel={onCancel}
      noCheckboxes={noCheckboxes}
    />
  ) : (
    <InvoiceLineRowForm
      onSubmit={handleSubmit}
      onCancel={onCancel}
      createdDate={line.date}
      clientId={clientId}
      noCheckboxes={noCheckboxes}
      showStatusColumn={showStatusColumn}
      defaultValues={{
        productId: line.productId,
        description: line.description || "",
        unitId: line.unitId,
        quantity: l10n.formatNumber(line.quantity),
        amount: l10n.formatCurrency(line.amount),
        discountPercentage: line.discountPercentage || "",
      }}
    />
  );
};

const hasSurcharge = (line: {
  percentage: string | null;
}): line is { percentage: string } => !!line.percentage;

export default EditInvoiceLineRow;
